import React from "react";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";

export type TabsProps<T extends string> = Readonly<{
  tabs: readonly T[];
  active: T;
  onChange: (tab: T) => void;
  counts?: Partial<Record<T, number>>;
}>;

const ScTabs = <T extends string>({
  tabs,
  active,
  onChange,
  counts,
}: TabsProps<T>) => {
  const { t } = useTranslation();

  return (
    <View className="flex-row gap-4">
      {tabs.map((tab) => {
        const isActive = tab === active;
        const count = counts?.[tab];

        return (
          <Pressable
            key={tab}
            onPress={() => onChange(tab)}
            className="flex-row items-start gap-1 px-2 py-1 rounded-lg hover:bg-ash-3"
          >
            <Text
              className={`pb-1 overflow-ellipsis ${
                isActive
                  ? "font-medium border-b-2 border-primary text-primary"
                  : "text-slate"
              }`}
            >
              {t(tab)}
            </Text>

            {count != null && count > 0 && (
              <View className="rounded-full min-w-[18px] h-[18px] px-1 items-center justify-center bg-primary">
                <Text className="text-white text-[10px] font-bold leading-none">
                  {count}
                </Text>
              </View>
            )}
          </Pressable>
        );
      })}
    </View>
  );
};

export default ScTabs;
